export default function getPointerPosition(event: MouseEvent | TouchEvent) {
    const threeViewer = (window as any).threeViewer;

    if (!threeViewer?.element) return {x:0, y:0}
    let position: { x: number; y: number } | null = null;


    const touches =
        (event as TouchEvent).touches?.length > 0
            ? (event as TouchEvent).touches
            : (event as TouchEvent).changedTouches || [];

    const isTouch =
        event.type === "touchstart" ||
        event.type === "touchmove" ||
        event.type === "touchend";

    //const isTwoFinger = touches?.length > 1;

    const eventX = isTouch
        ? touches[0]?.clientX
        : (event as MouseEvent)?.clientX;
    const eventY = isTouch
        ? touches[0]?.clientY
        : (event as MouseEvent)?.clientY;

    const rect = threeViewer.element.getBoundingClientRect();

    const x = ((eventX - rect.left) / threeViewer.element.clientWidth) * 2 - 1;
    const y = -((eventY - rect.top) / threeViewer.element.clientHeight) * 2 + 1;

    position = { x, y };


    return  position ;
}